module.exports = __webpack_public_path__ + "img/img5-2.391a438b.png";